import { STEPS } from "@/content";
import { SITE } from "@/constants/testIds";
import { Reveal, SectionHead } from "./Reveal";

export const Method = () => (
  <section id="metodo" className="section-pad bg-white">
    <div className="container-x">
      <SectionHead
        index="04"
        eyebrow="Come lavoriamo"
        title="Come funziona. In quattro passi."
      />
      <ol className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
        {STEPS.map((s, i) => (
          <Reveal as="li" key={s.n} delay={i * 110} data-testid={SITE.stepItem(s.n)} className="relative">
            <div className="flex items-center gap-4">
              <span className="flex h-12 w-12 items-center justify-center rounded-full bg-navy-900 text-sm font-semibold text-white">
                {s.n}
              </span>
              <span className="hidden lg:block h-px flex-1 bg-navy-100" />
            </div>
            <h3 className="mt-7 text-lg font-semibold text-navy-900">{s.title}</h3>
            <p className="mt-3 text-[15px] leading-relaxed text-navy-500">{s.text}</p>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
